import {useEffect} from 'react';

import {AdFoxStatsEvent} from '@shared/Ads/Yandex/types';

import {useAdfoxStore} from '@shared/Ads/Yandex/store';

import YandexAdScript from '../../YandexAdScript';

const intervalMs = 100;
const attemptsLimit = 30;

const createEvent = ({
  attemptNumber,
  errorType,
}: {
  attemptNumber: number;
  errorType?: string;
}): AdFoxStatsEvent => ({
  eventName: 'AdFoxLoaded',
  payload: {
    attempt_number: `${attemptNumber}`,
    has_error: `${+!!errorType}`,
    ...(errorType && {error_type: errorType}),
  },
});

export const ScriptLoader = () => {
  const {
    adFoxScriptState: {setState, state},
    adFoxStatsEvents: {set},
  } = useAdfoxStore();
  useEffect(() => {
    if (state !== 'not_initialized') {
      return;
    }
    let attemptNumber = 0;

    const interval = setInterval(() => {
      attemptNumber++;
      if (window.Ya?.adfoxCode && window.yaContextCb) {
        setState('loaded');
        set(createEvent({attemptNumber}));
      } else if (attemptNumber >= attemptsLimit) {
        setState('failed');
        set(createEvent({attemptNumber, errorType: 'attempts_limit_exceeded'}));
      }
    }, intervalMs);
    return () => {
      clearInterval(interval);
    };
  }, [state, set, setState]);

  return (
    <YandexAdScript
      onError={() => {
        setState('failed');
        set(createEvent({attemptNumber: 0, errorType: 'script_blocked'}));
      }}
    />
  );
};
